var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconThumbUpFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H6V21H3V10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 3H13.5303C12.5383 3 11.6689 3.66401 11.4079 4.62114L10.7967 6.8622C10.4282 8.21341 9.35874 9.26031 8 9.6V20.6H15.8263C17.7693 20.6 19.4824 19.3255 20.0407 17.4643L21.5504 12.4322C21.9738 11.0206 20.9168 9.6 19.4431 9.6H17.35C16.7425 9.6 16.25 9.10751 16.25 8.5V4.1C16.25 3.49249 15.7575 3 15.15 3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconThumbUpFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconThumbUpFilled.b8866c99938d3b48f25cba77f35c2d83.svg";